import { gql } from "@apollo/client";

export const GET_OPIOIDES = gql`
query GetOpioides {
    opioides {
        idOpioide
        decripcion
    }
}`;

export const adaptOpioide = (opioide) => {
  return {
    idOpioide: opioide?.idOpioide,
    opioide: opioide?.decripcion
  };
};

export const adaptOpioideArray = (data) => {
  return structuredClone(data?.opioides).map((opioide) => adaptOpioide(opioide));
};